<template>
  <div class="d-flex align-items-baseline">
    <span class="material-icons md-12 me-1">radio_button_checked</span>
    <p>{{ content }}</p>
  </div>
</template>

<script>
export default {
  name: 'RadioButtonListField',
  props: {
    content: {
      type: String,
    },
  },
}
</script>

<style lang="scss" scoped>
.material-icons {
  position: relative;
  top: 1px;
}
p {
  margin: 0;
  word-break: break-word;
}
</style>
